import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { removeEmpty } from 'utils/functions';
import Client from 'containers/app/client';
import { getValidateStatus, getHelp } from 'utils/form';
import FormActions from 'components/form-actions';
import { Spin } from 'antd';
import StagePropTypes from './prop-types';
import schema from './schema';
import DbsForm from './dbs-form';
import { DB_PREFIX_REGISTER } from './constants';

const Component = ({ user, onSubmit, onBack, initialValues }) => {
  const [submitting, setSubmitting] = useState(false);

  const handleValues = async (values) => {
    setSubmitting(true);
    await Client.setUserProfile(removeEmpty(values));
    await Client.sendDBSInfo(removeEmpty(values));
    setSubmitting(false);
  };

  const uploadTo = `user/${user.uid}/identityOfficialDocuments/`;
  const handleSubmit = (values, actions) => {
    onSubmit(values, actions, handleValues);
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ values, errors, touched, ...rest }) => {
        const validateStatus = getValidateStatus(values, errors, touched);
        const help = getHelp(values, errors, touched);
        const { registered } = values[DB_PREFIX_REGISTER];

        return (
          <Spin spinning={submitting}>
            <DbsForm
              {...rest}
              values={values}
              validateStatus={validateStatus}
              help={help}
              uploadTo={uploadTo}
            >
              <FormActions
                showLogout={registered === false}
                showSaveLater={false}
                onBack={() => {
                  onBack(values, handleValues);
                }}
              />
            </DbsForm>
          </Spin>
        );
      }}
    </Formik>
  );
};

Component.propTypes = {
  user: PropTypes.shape({ uid: PropTypes.string.isRequired }).isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  initialValues: StagePropTypes.isRequired,
};

Component.defaultProps = {
  // onSubmit: () => {},
};

export default Component;
